__turbopack_context__.v({
  "copy": "styles-module-scss-module__bNNKEa__copy",
  "cta": "styles-module-scss-module__bNNKEa__cta",
  "desktopHeadline": "styles-module-scss-module__bNNKEa__desktopHeadline",
  "eyebrow": "styles-module-scss-module__bNNKEa__eyebrow",
  "headline": "styles-module-scss-module__bNNKEa__headline",
  "mobileHeadline": "styles-module-scss-module__bNNKEa__mobileHeadline",
  "panel": "styles-module-scss-module__bNNKEa__panel",
  "signal": "styles-module-scss-module__bNNKEa__signal",
  "stickyShell": "styles-module-scss-module__bNNKEa__stickyShell",
  "supportingText": "styles-module-scss-module__bNNKEa__supportingText",
  "upgradePanel": "styles-module-scss-module__bNNKEa__upgradePanel",
});
